/*
 * Alertes contextuelles du bilan : avertissement session, prudence
 * medicale, variantes nurture et prudent, limites du bilan.
 */

import { Info, Lock, ShieldAlert } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export const SessionWarningAlert = () => (
  <Alert className="mt-4 rounded-2xl bg-[rgba(226,246,255,0.55)] border-[rgba(35,82,119,0.18)]" data-testid="bilan-session-warning">
    <Lock className="h-4 w-4 text-[#235277]" />
    <AlertDescription className="text-xs leading-relaxed text-[#333333]">
      Ton bilan existe uniquement dans cette session. Si tu fermes cette page avant de
      télécharger ou de recevoir ton bilan, il sera définitivement effacé.
    </AlertDescription>
  </Alert>
);

export const MedicalCautionAlert = () => (
  <Alert className="mt-6 rounded-2xl bg-[#FDF6E7] border-[rgba(94,85,21,0.3)]" data-testid="bilan-medical-caution">
    <ShieldAlert className="h-4 w-4 text-[#5E5515]" />
    <AlertTitle className="font-heading text-sm text-[#5E5515]">Une précaution importante</AlertTitle>
    <AlertDescription className="text-xs leading-relaxed text-[#5E5515]">
      Tu as indiqué qu’un professionnel de santé te déconseille ou limite la pratique d’une
      activité physique, ou que tu n’en es pas certaine. Avant toute modification de ta pratique,
      sollicite l’avis du professionnel compétent qui suit ta situation. Ton bilan ne contient
      volontairement aucune recommandation sportive.
    </AlertDescription>
  </Alert>
);

const VARIANT_NOTES = {
  nurture: {
    testId: "bilan-nurture-note",
    text:
      "Prends le temps d’explorer ton bilan et ta première action. Quand tu te sentiras " +
      "prête, l’échange avec Gino reste accessible à tout moment sur cette page.",
  },
  prudent: {
    testId: "bilan-prudent-note",
    text:
      "Un échange d’orientation adapté permet de faire le point sereinement, sans " +
      "engagement. L’accompagnement éventuel respectera toujours les indications de ton " +
      "professionnel de santé.",
  },
};

export const VariantNoteAlert = ({ variant }) => {
  const note = VARIANT_NOTES[variant];
  if (!note) return null;
  return (
    <Alert className="mt-6 rounded-2xl bg-[rgba(226,246,255,0.55)] border-[rgba(35,82,119,0.18)]" data-testid={note.testId}>
      <Info className="h-4 w-4 text-[#235277]" />
      <AlertDescription className="text-xs leading-relaxed text-[#333333]">{note.text}</AlertDescription>
    </Alert>
  );
};

export const DisclaimerAlert = ({ noCycle }) => (
  <Alert className="mt-6 rounded-2xl bg-white border-[rgba(35,82,119,0.18)]" data-testid="bilan-non-medical-disclaimer">
    <ShieldAlert className="h-4 w-4 text-[#235277]" />
    <AlertTitle className="font-heading text-sm text-[#060606]">Les limites de ce bilan</AlertTitle>
    <AlertDescription className="text-xs leading-relaxed text-[#333333]">
      Ce bilan est un outil d’orientation et ne constitue pas un diagnostic médical. Il ne remplace
      pas l’avis d’un médecin ou d’un professionnel de santé qualifié.
      {noCycle && " Ton bilan est construit sur tes variations individuelles, sans référence à une phase de cycle."}
    </AlertDescription>
  </Alert>
);
